import { connect } from 'react-redux';
import moment from 'moment';
import { createSelector } from 'reselect';
import * as actions from '../../actions/tools';
import { VideoTool } from '../../components/tools';

const userSelector = state =>
  state.tools.selectedUser;

const mediaIndexSelector = state =>
  state.tools.selectedMediaIndex;

const absoluteTimeSelector = state =>
  state.tools.absoluteTime;

const trackSelector = state => state.map.selectedTrack;

const mediasSelector = createSelector(
  trackSelector,
  track => track && track.medias,
);

const mediaSelector = createSelector(
  mediasSelector,
  mediaIndexSelector,
  (medias, index) => (medias && index !== undefined) && medias[index],
);

const mediaDateSelector = createSelector(
  mediaSelector,
  media => (media ? moment(media.start_time).format('DD.MM') : ''),
);

const tokenSelector = state =>
  state.auth.userInfo.token;

const MAP_HOST = 'https://adspromote.ru:8000';

const mediaUrlSelector = createSelector(
  tokenSelector,
  mediaSelector,
  (token, media) => (media ? `${MAP_HOST}/api/media/file/${token}/${media.filename}` : ''),
);

const videoPositionSelector = createSelector(
  mediaSelector,
  absoluteTimeSelector,
  (media, absoluteTime) => {
    if (media && absoluteTime !== undefined) {
      const t0 = media.start_time;
      const t1 = media.end_time;
      const d0 = t1 - t0;
      const d1 = absoluteTime - t0;
      return d1 / d0;
    }
    return undefined;
  },
);

const mapStateToProps = state => ({
  user: userSelector(state),
  medias: mediasSelector(state),
  mediaIndex: mediaIndexSelector(state),
  mediaUrl: mediaUrlSelector(state),
  videoState: state.video.state,
  playbackRate: state.video.playbackRate,
  videoPosition: videoPositionSelector(state),
  adminCheckActive: state.tools.adminCheckActive,
  mediaDate: mediaDateSelector(state),
});

const mapDispatchToProps = dispatch => ({
  onTimeUpdate: player => dispatch(
    actions.updateVideoTime(player.currentTime(), player.duration(), player.playbackRate()),
  ),
  onEnded: () => {
    dispatch(actions.setVideoState('ended'));
    dispatch(actions.selectNextMedia());
  },
  onPlaying: () =>
    dispatch(actions.setVideoState('playing')),
  onPause: () =>
    dispatch(actions.setVideoState('pause')),
  onNavigate: to => {
    switch (to) {
      case 'first':
        dispatch(actions.selectFirstMedia());
        break;
      case 'prev':
        dispatch(actions.selectPrevMedia());
        break;
      case 'next':
        dispatch(actions.selectNextMedia());
        break;
      case 'last':
        dispatch(actions.selectLastMedia());
        break;
      default:
    }
  },
  onAdminCheckActive: active => dispatch(
    actions.setAdminCheckActive(active),
  ),
  onLoadedMetadata: () => dispatch(actions.setVideoState('playing')),
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoTool);



// WEBPACK FOOTER //
// ./src/containers/tools/VideoTool.js